const colors = {
  primary: '#007bff',
  secondary: '#6c757d',
  success: '#28a745',
  danger: '#dc3545',
  warning: '#ffc107',
  info: '#17a2b8',
  light: '#f8f9fa',
  dark: '#343a40',
};

const textColors = {
  primaryText: '#212529',
  secondaryText: '#6c757d',
  successText: '#155724',
  dangerText: '#721c24',
  warningText: '#856404',
  infoText: '#0c5460',
  lightText: '#818182',
  darkText: '#1b1e21',
  whiteText: '#ffffff',
  blackText: '#000000',
};

const backgroundColors = {
  primaryBackground: '#e9ecef',
  secondaryBackground: '#f8f9fa',
  successBackground: '#d4edda',
  dangerBackground: '#f8d7da',
  warningBackground: '#fff3cd',
  infoBackground: '#d1ecf1',
  lightBackground: '#fefefe',
  darkBackground: '#c6c8ca',
};

const borderColors = {
  primaryBorder: '#007bff',
  secondaryBorder: '#6c757d',
  successBorder: '#28a745',
  dangerBorder: '#dc3545',
  warningBorder: '#ffc107',
  infoBorder: '#17a2b8',
  lightBorder: '#f8f9fa',
  darkBorder: '#343a40',
};

const buttonColors = {
  primaryButton: '#007bff',
  secondaryButton: '#6c757d',
  successButton: '#28a745',
  dangerButton: '#dc3545',
  warningButton: '#ffc107',
  infoButton: '#17a2b8',
  lightButton: '#f8f9fa',
  darkButton: '#343a40',
};

export { colors, textColors, backgroundColors, borderColors, buttonColors };